export default "__VITE_ASSET__f4dc5706__"